import type { SharedConfig } from './env';

const sharedConfig: SharedConfig = {
  app: {
    environment: process.env.NODE_ENV,
    url: 'http://localhost:3001',
  },
  newRelic: {
    accountID: '3160087',
    agentID: '601307333',
    licenseKey: 'NRJS-e0bf463af6b8348b408',
    trustKey: '3080127',
  },
};

export const PAYMENT_METHODS = {
  BANKBILLING: 'bankBilling',
  PIX: 'pix',
  CREDIT_CARD: 'creditCard',
  BOLETO: 'boleto',
};

export const PAYMENT_STATUS = {
  PAID: 'paid',
  OPEN: 'Em Aberto',
  UNBILLED: 'unbilled',
  EXPIRED: 'expired',
};

export const BRANDS = {
  EUD: 'eudora',
  BOT: 'boticario',
};

export const DRAWERS = {
  PAYMENT_DETAIL: 'PaymentDetail',
  RENEGOTIATION: 'Renegotiation',
  CADASTRAL_CHANGE: 'CadastralChange',
};

export const QUERYPARAMS = {
  IS_DRAWER: 'isDrawer',
  PAYMENT_ID: 'paymentId',
  IS_OPEN: 'isOpen',
  CADASTRAL_TYPE: 'cadastralType',
  STAGE: 'stage',
  STATUS: 'status',
};

export const CADASTRAL_CHANGE = {
  PhoneChange: 'phone',
} as const;
// prettier-ignore
export type CadastralChangeType = typeof CADASTRAL_CHANGE[keyof typeof CADASTRAL_CHANGE];

export enum ChangeStagesEnum {
  VALIDATE = 'senha',
  FORM = 'confirmacao',
  SUCCESS = 'sucesso',
  ERROR = 'erro',
  IMPORTANT_INFORMATION = 'informacoes-importantes',
  CONFIRMATION_MODAL = 'modal-confirmacao',
}

export const PHONE_CHANGE_STAGES = {
  VALIDATE: ChangeStagesEnum.VALIDATE,
  FORM: ChangeStagesEnum.FORM,
  SUCCESS: ChangeStagesEnum.SUCCESS,
  ERROR: ChangeStagesEnum.ERROR,
};

export const ADDRESS_CHANGE_STAGES = {
  VALIDATE: ChangeStagesEnum.VALIDATE,
  FORM: ChangeStagesEnum.FORM,
  IMPORTANT_INFORMATION: ChangeStagesEnum.IMPORTANT_INFORMATION,
  CONFIRMATION_MODAL: ChangeStagesEnum.CONFIRMATION_MODAL,
  SUCCESS: ChangeStagesEnum.SUCCESS,
  ERROR: ChangeStagesEnum.ERROR,
};

export type PhoneChangeStagesType = keyof typeof PHONE_CHANGE_STAGES;
export type AddressChangeStagesType = keyof typeof ADDRESS_CHANGE_STAGES;

export const ORDERS_TABS = {
  payments: 'a-pagar',
  history: 'historico',
};
export const ENVIRONMENTS = {
  PRODUCTION: 'production',
  HOMOLOGATION: 'staging',
  DEVELOPMENT: 'development',
  LOCAL: 'local',
};

export const CATALOGS = {
  MULTIBRAND: 'multimarca',
};
export const ONBOARDINGS = {
  ALREADY_SAW_ONBOARDING: 'alreadySawOnboarding',
  IMAGES_TO_SHARE: 'imagesToShare',
};
export const SLIDES_TO_SHOW = {
  mobile: 1,
  desktop: 4,
};

export enum ORDERS_STATUS {
  CANCELED = 'canceled',
}

export default sharedConfig;
